export const sortByInactiveStatusAndLastName = <
  T extends { lastName: string; isActive: () => boolean },
>(
  list: T[],
): T[] => {
  const statusOrder = { active: 1, inactive: 2 };

  return list.sort((a, b) => {
    const statusA = a.isActive() ? 'active' : 'inactive';
    const statusB = b.isActive() ? 'active' : 'inactive';

    if (statusOrder[statusA] !== statusOrder[statusB]) {
      return statusOrder[statusA] - statusOrder[statusB];
    }

    return a.lastName.toLowerCase().localeCompare(b.lastName.toLowerCase());
  });
};

/**
 * Returns a lowercase string value from a row for sorting.
 * Priority: compositeFieldMap > selector > _.get fallback.
 */
export const getSortValue = <T>(
  row: T,
  columnId: string,
  selector?: (row: T) => unknown,
  compositeFieldMap?: Record<string, (row: T) => string>,
): string => {
  if (compositeFieldMap?.[columnId]) {
    return compositeFieldMap[columnId](row);
  }

  if (typeof selector === 'function') {
    const raw = selector(row);
    return typeof raw === 'string'
      ? raw.toLowerCase()
      : String(raw ?? '').toLowerCase();
  }

  const rawValue = _.get(row, columnId);
  return typeof rawValue === 'string'
    ? rawValue.toLowerCase()
    : String(rawValue ?? '').toLowerCase();
};
